module.exports = __webpack_public_path__ + "static/Calculator-d3786f7a28485bafd8cea866db494dfc.svg";